import React from "react";
import FunctionsData from "../../Functions/FunctionsData";
import {Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import jwt from "jsonwebtoken";
import scissors from "../../img/scissors.png";

export default function CommunityStep4Final ({outreach, animals, setAnimals, frmOrderID, currentVetArr, aStep, setAStep, jwtKey, frmFn, frmLn, frmEmail,sponsorId, sponsorName, sponsorProgram, sponsorCost, sponsorMicrochipExtraCost, sponsorEmailText, sponsorLogo, orderDescription}) {

    const programLabel = outreach ? "Outreach" : "Community";
    function printVoucher() {

        window.gtag('event', 'action', {
            category: 'User',
            action: 'Clicked Print Voucher Button'
        });

        let arr = [];
        let expiry = new Date().toISOString().slice(0, 10);
        for (let x in animals) {
            const r = animals[x];
            arr.push({
                name: r.name,
                voucher: r.voucher,
                expiry_date: r.expiry_date,
                expiry: r.expiry_date
            });
            if (expiry < r.expiry_date) expiry = r.expiry_date;
        }


        const urlJwt = {
            name: currentVetArr.business_name,
            order_id: frmOrderID,
            email: frmEmail,
            user: frmFn + " " + frmLn,
            vet_id: currentVetArr.id,
            expiry: new Date(expiry)
        };

        let url = 'print/?com=1&cid=' + jwt.sign({...urlJwt, vouchers: arr}, jwtKey);
        //console.log(url);
        const newWindow = window.open(url, '_blank',
            'noopener,noreferrer'
        );

        if (newWindow) newWindow.opener = null
    }

    return (
        <div>
            <div className={"thank-you"} style={{textAlign: 'center'}}>

                <p>
                    Voucher confirmation has been sent to the email address entered during registration. The email includes the {programLabel} Desexing Voucher(s), and the details of the vet clinic that was selected.
                </p>

                <div className={"consent-block"} style={{display: 'flex'}}>
                    <div>
                        <img src={scissors} style={{height: 50, width: 50, marginTop: 0, marginRight: 20}}/>
                    </div>
                    <div>
                        <strong>Next Step:</strong> Advise the owner that they will need to contact the vet clinic that was selected to arrange an appointment and book in their animal(s).
                    </div>
                </div>

                <p>Please note: If the voucher confirmation email was sent directly to the owner, advise the owner that if they do not receive an email with their voucher(s) within 24hrs, please check their spam folder. If it’s not there, please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}>snipnchip@spca.nz</a>
                </p>
                <div style={{marginBottom: 20}}>
                    <Button size="full"
                            onClick={printVoucher}
                            sx={{width: '100%'}}
                            variant={"contained"}
                    >
                        Print voucher
                    </Button>
                </div>
                <SurveyCheckList frmOrderID={frmOrderID} outreach={outreach}/>
            </div>
            <Button size="full"
                    onClick={() => {
                        setAnimals([]);
                        setAStep(2)
                    }}
                    sx={{margin: 1}}>
                Get another voucher
            </Button>
            <Button size="full"
                    onClick={() => {
                        window.location.reload();
                    }}
                    sx={{margin: 1}}>
                Close
            </Button>
        </div>
    )
}

const communityOptions = [
    { slug: "community_centre", name: "Came into Centre needing help" },
    { slug: "community_called_centered", name: "Called Centre needing help" },
    { slug: "community_referred_vet", name: "Referred by a Vet Clinic" },
    { slug: "community_inspectorate", name: "Related to an Inspectorate Job, or known by Inspector" },
    { slug: "community_self_referred", name: "Self Referred - knew about programme" },
    { slug: "community_referred_other_organisation", name: "Referred by another organisation ie Kāinga Ora, Aviva, Police, Council etc" },
    { slug: "community_other", name: "Other" },
  ];
  
  const outreachOptions = [
    { slug: "targeted_campaign", name: "Responded to a targeted campaign my organisation was running" },
    { slug: "contacted_directly", name: "Contacted my organisation directly for help" },
    { slug: "referred_by_vet", name: "Referred to my organisation by a vet clinic" },
    { slug: "referred_by_other", name: "Referred to my organisation by another organisation" },
    { slug: "other", name: "Other" },
  ];
  
  function SurveyCheckList({ frmOrderID, outreach }) {
    const [value, setValue] = React.useState("");
    const options = outreach ? outreachOptions : communityOptions;
  
    function handleChange(e) {
      const selected = e.target.value;
      setValue(selected);
      FunctionsData.postData(`/api/orders/order/${frmOrderID}`, {
        marketing_source: selected,
      }).then(() =>
        window.gtag("event", "action", {
          category: "User",
          action: "Filled out survey",
        })
      );
    }
  
    if (value) {
      return (
        <div className="consent-block">
          <h3>Thank you for your feedback.</h3>
        </div>
      );
    }
  
    return (
      <div className="consent-block">
        <FormControl component="fieldset">
          <FormLabel component="legend">How was this person referred to you?</FormLabel>
          <RadioGroup
            aria-label="referral-source"
            name="referral-source-group"
            value={value}
            onChange={handleChange}
          >
            {options.map((o) => (
              <FormControlLabel
                key={o.slug}
                value={o.slug}
                control={<Radio />}
                label={o.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
  